import { type ConflictKmat, FullCsticId, type Kmat, type LinearSubstep } from "~/features/configurator/Linear/models";
import { fromExtraValidationToDirtyParamName } from "~/features/configurator/Linear/utils";
import { getExtraValidationParamName } from "~/features/configurator/Linear/namingUtils";
import { csticHasValue } from "~/features/configurator/common/v2/helper";
import type { KmatType } from "~/features/configurator/Linear/kmatType";

export function getConflictCsticNames(conflicts: ConflictKmat[]): string[] {
  return conflicts.flatMap((conflict) => conflict.cstics.map((cstic) => cstic.name));
}

export function validateFromDefinition(
  substep: LinearSubstep,
  kmats: Record<KmatType, Kmat[]>,
  conflicts: ConflictKmat[],
) {
  const conflictedCstics = getConflictCsticNames(conflicts);

  let valid = true;
  const extraValidations: Record<string, boolean> = {};
  const additionalData: Record<string, boolean> = {};

  if (!substep.isVisible) {
    return {
      substepValid: true,
      extraValidations: {},
      additionalData: {},
    };
  }

  if (substep.tiles.length || substep.groupedTiles.length) {
    // Validate that a tile is selected
    valid = substep.selectedTile !== null;
  }
  const inputCsticsPerKmat = Array.isArray(substep.cstics)
    ? substep.cstics.map((c) => c.input)
    : [substep.cstics.input];

  inputCsticsPerKmat.forEach((inputCstics, index) => {
    Object.values(inputCstics).forEach((cstic) => {
      const kmat = kmats[cstic.kmatType][index];
      let csticValid = true;

      if (cstic.visible) {
        csticValid = !conflictedCstics.includes(cstic.name);
      }

      if (cstic.visible && cstic.required) {
        csticValid = csticValid && csticHasValue(kmat, cstic.name);
      }
      valid = valid && csticValid;

      const key = getExtraValidationParamName(
        FullCsticId({
          key: cstic.name,
          index,
          type: cstic.kmatType,
        }),
      );
      extraValidations[key] = csticValid;
      const dirtyKey = fromExtraValidationToDirtyParamName(key);
      additionalData[dirtyKey] = true;
    });
  });

  return {
    substepValid: valid,
    extraValidations,
    additionalData,
  };
}
